import React from 'react';

import { SimpleTickIcon } from '@nw/shared/ui';

import {
  NumberedProgressBarContainer,
  NumberedProgressBarStepContainer,
  NumberedProgressBarStepNumber,
  NumberedProgressBarStepText,
  ProgressBar,
  ProgressBarContainer,
  ProgressBarFiller
} from './styledComponents';

type Props = {
  totalProgressBars: number;
  currentStep: number;
  numberedProgressBarStepsTitles?: string[];
  customStyles?: string;
};

const NumberedProgressbar: React.FC<Props> = ({
  totalProgressBars,
  currentStep,
  numberedProgressBarStepsTitles,
  customStyles
}) => {
  if (
    !numberedProgressBarStepsTitles ||
    numberedProgressBarStepsTitles.length === 0
  ) {
    return null; // or a fallback UI
  }

  const calculateProgress = () =>
    Math.round(((currentStep - 1) / (totalProgressBars - 1)) * 100);

  const getStepClassNames = (stepNumber: number) => {
    const isCurrent = stepNumber === currentStep;
    const isFinished = stepNumber < currentStep;
    const isFinalStep = stepNumber === totalProgressBars;

    return {
      numberClass: [
        isCurrent && 'current-step-number',
        isFinished && 'finished-step-number',
        isCurrent && isFinalStep && 'final-step-number'
      ]
        .filter(Boolean)
        .join(' '),
      textClass: [
        isCurrent && 'current-step-text',
        isFinished && 'finished-step-text',
        isCurrent && isFinalStep && 'final-step-text'
      ]
        .filter(Boolean)
        .join(' ')
    };
  };

  return (
    <NumberedProgressBarContainer>
      <ProgressBarContainer>
        <ProgressBar>
          <ProgressBarFiller width={calculateProgress()} />
        </ProgressBar>
      </ProgressBarContainer>

      {numberedProgressBarStepsTitles.map((stepTitle, index) => {
        const stepNumber = index + 1;
        const { numberClass, textClass } = getStepClassNames(stepNumber);

        return (
          <NumberedProgressBarStepContainer
            key={stepNumber}
            customStyles={customStyles}
          >
            <NumberedProgressBarStepNumber className={numberClass}>
              {numberClass === 'finished-step-number' ||
              numberClass === 'final-step-number' ? (
                <SimpleTickIcon />
              ) : (
                stepNumber
              )}
            </NumberedProgressBarStepNumber>
            {stepTitle && (
              <NumberedProgressBarStepText className={textClass}>
                {stepTitle}
              </NumberedProgressBarStepText>
            )}
          </NumberedProgressBarStepContainer>
        );
      })}
    </NumberedProgressBarContainer>
  );
};

export { NumberedProgressbar };
